<template>
  <div
    :style="{
      backgroundImage: zoomIsActive ? 'none' : bg_img,
      backgroundSize: bgsize,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center center',
      maxWidth: max_width,
      position: 'relative',
    }"
    class="media"
    :class="{ 'is-circled': circled }"
  >
    <div
      v-if="zoomable && device.isMobileOnly === false"
      :style="{
        position: 'absolute',
        top: '10px',
        right: 0,
        left: 0,
        marginLeft: 'auto',
        marginRight: 'auto',
        width: '125px',
        height: '45px',
        padding: '10px',
        textAlign: 'center',
        backgroundColor: 'rgba(250, 250, 250, 0.6)',
        boxShadow: zoomIsActive
          ? '0px 0px 5px 5px rgba(158,243,165,0.75)'
          : 'none',
        zIndex: 29,
      }"
    >
      <b-switch v-model="zoomIsActive">Zoom</b-switch>
    </div>

    <img
      v-if="zoomIsActive === false"
      :width="img_width"
      :height="img_height"
      :style="{ width: img_width, height: img_height }"
      src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
    />

    <ImageMagnifier
      v-if="zoomable && zoomIsActive === true"
      :src="img"
      :zoom-src="full || img"
      :width="img_width"
      :height="img_height"
      zoom-width="250"
      zoom-height="250"
      mask-width="150"
      mask-height="150"
    />

    <div
      style="position: absolute; bottom: -25px; width: 100%"
      class="has-text-centered mt-5"
      v-if="zoomable && device.isMobileOnly"
    >
      <b-button
        type="is-light"
        class="has-text-primary"
        icon-left="magnify-scan"
        @click="isImageModalActive = true"
        >Ampliar</b-button
      >
    </div>

    <b-modal v-model="isImageModalActive">
      <img :src="full || img" />
    </b-modal>
  </div>
</template>

<script>
import AppMappers from "@/store/app-global-mappers";
import ImageMagnifier from "@/components/media/ImageMagnifier.vue";

export default {
  name: "MediaImg",
  props: {
    size: {
      type: String,
      default: "800x600",
    },
    mobile_size: {
      type: String,
      default: "600x300",
    },
    img: String,
    full: String,
    maxwidth: Number,
    bgsize: {
      type: String,
      default: "contain",
    },
    circled: {
      type: Boolean,
      default: false,
    },
    height_auto: {
      type: Boolean,
      default: false,
    },
    zoomable: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [AppMappers],
  components: { ImageMagnifier },
  data() {
    return {
      width: 800,
      height: 600,
      mobile_width: 600,
      mobile_height: 250,
      zoomIsActive: false,
      isImageModalActive: false,
    };
  },

  created() {
    let sizes, mobile_sizes;

    sizes = this.size.split("x");
    this.width = sizes[0];
    this.height = sizes[1];

    mobile_sizes = this.mobile_size.split("x");
    this.mobile_width = mobile_sizes[0];
    this.mobile_height = mobile_sizes[1];
  },

  computed: {
    bg_img() {
      if (this.img) return `url('${this.img}')`;

      return null;
    },

    max_width() {
      if (this.maxwidth) return `${this.maxwidth}px`;

      return null;
    },

    img_width() {
      if (this.device.isMobileOnly) {
        return `${this.mobile_width}px`;
      }

      return `${this.width}px`;
    },

    img_height() {
      if (this.height_auto) {
        return "auto";
      }

      if (this.device.isMobileOnly) {
        return `${this.mobile_height}px`;
      }
      return `${this.height}px`;
    },
  },
};
</script>

<style lang="scss">
.media {
  &.is-circled {
    border-radius: 50%;
  }
}
</style>